import Topbar from "@/pages/home/components/Topbar";
import Hero from "@/pages/home/components/Hero";
import Feed from "@/pages/home/components/Feed";
import Collections from "@/pages/home/components/Collections";
import Zones from "@/pages/home/components/Zones";
import Encrypted from "@/pages/home/components/Encrypted";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-cream-50 font-sans">
      <Topbar />
      <main>
        <Hero />
        <Feed />
        <Collections />
        <Zones />
        <Encrypted />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}